export default __webpack_public_path__ + "static/media/IMG_20220905_211421_336.5b877831.jpg";